import Link from "next/link";
import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";
import { ArrowRightCircle } from "lucide-react";

export default function ContactezNous({ data }: BlockProps) {
  if (!data) return null;

  const images = data.image || [];

  return (
    <section className="relative overflow-hidden bg-orange px-6 py-16 text-white md:px-10 lg:min-h-[420px] lg:px-16 lg:py-20">
      {/* Cercles décoratifs */}
      <div className="absolute -left-8 top-8 h-20 w-20 rounded-full bg-yellow md:h-24 md:w-24" />
      <div className="absolute left-[32%] -bottom-8 h-20 w-20 rounded-full bg-yellow md:h-24 md:w-24" />
      <div className="absolute right-[-30px] top-2/3 h-20 w-20 -translate-y-1/2 rounded-full bg-yellow md:h-24 md:w-24" />
      <div className="absolute right-[28%] -top-10 h-24 w-24 rounded-full bg-yellow md:h-32 md:w-32" />

      {/* Images décoratives */}
      {images[1]?.url && (
        <div className="absolute bottom-0 left-0 z-0 h-[150px] w-[150px] md:h-[220px] md:w-[220px] lg:h-[260px] lg:w-[260px]">
          <Image
            src={images[1].url}
            alt={images[1].alternativeText || "Image décorative gauche"}
            fill
            className="object-contain object-bottom-left"
          />
        </div>
      )}

      {images[0]?.url && (
        <div className="absolute right-0 top-0 z-0 h-[150px] w-[150px] md:h-[220px] md:w-[220px] lg:h-[250px] lg:w-[250px]">
          <Image
            src={images[0].url}
            alt={images[0].alternativeText || "Image décorative droite"}
            fill
            className="object-contain object-top-right"
          />
        </div>
      )}

      {/* Contenu centré */}
      <div className="relative z-10 mx-auto flex max-w-[920px] flex-col items-center justify-center text-center">
        <h2 className="max-w-[820px] font-literata text-[30px] font-bold leading-[1.25] text-white md:text-[42px] lg:text-[54px]">
          {data.titre}
        </h2>

        <div className="mt-10">
          <Link
            href={data?.cta?.link || "#"}
            className="inline-flex items-center gap-3 rounded-full bg-yellow px-6 py-3 text-[16px] font-semibold text-black transition hover:opacity-90 md:px-8 md:py-4 md:text-[20px]"
          >
            {data?.cta?.text}
            <ArrowRightCircle className="h-5 w-5 md:h-6 md:w-6" />
          </Link>
        </div>
      </div>
    </section>
  );
}